import filterList from '@shared/lib/general/filterList';

const filterCycleData = (data, systemFilter) => {
  let filtered = data.slice();
  if (systemFilter.thermostatZone.length) {
    const serialNumbers = [];
    systemFilter.thermostatZone.forEach((sf) => {
      const tZones = sf.tZoneSN;
      tZones.forEach((sn) => {
        serialNumbers.push(sn);
      });
    });
    filtered = filtered.filter((cycle) => {
      if (cycle.supplyAir) {
        return serialNumbers.includes(`${cycle.uid}-${cycle.supplyAir.deviceId}`);
      }
      return false;
    });
  }

  if (systemFilter.cycleTypeFilter.length) {
    const cycleTypes = systemFilter.cycleTypeFilter;
    filtered = filtered.filter(cycle => cycleTypes.includes(cycle.acMode.toLowerCase()));
  }

  if (systemFilter.dateFilter) {
    const newDateData = filterList(systemFilter.dateFilter, filtered, 'cycleDate');
    filtered = newDateData.slice();
  }

  return filtered;
};

export default filterCycleData;
